module.exports = __webpack_public_path__ + "img/bz.04a7ff96.svg";